import mirrorCreator from 'mirror-creator';

const actionTypes = mirrorCreator(['ADD_COMMENT', 'REMOVE_COMMENT']);

export default actionTypes;
